import React from 'react';

function MiniCard({ reports }) {
  return (
    <div className="dashboardCardStats">
        {reports.map((item, index) => {
            return(
                <div className="card" key={index} onClick={item?.onClick ?? ''} style={item?.onClick ? { cursor: 'pointer' } : { cursor: '' }}>
                    <div className='statCardWrapper d-flex'>
                        <div className='iconBox me-2' style={{backgroundColor: item.iconBgColor, color: item.iconColor }}>
                            {item.icon && React.createElement(item.icon, { style: { fontSize: '2rem', color: 'inherit' } })}
                        </div>
                        <div className='statWrapper'>
                            <div className='statCount'>{item.count}</div>
                            <div className='statText'>{item.text}</div>
                        </div>
                    </div>
                </div>
            )
        })}
    </div>
  );
}

export default MiniCard;
